const Index = resolve => require.ensure([], () => resolve(require('./Index.vue')), 'group-course');
const Attendance = resolve => require.ensure([], () => resolve(require('./Attendance.vue')), 'group-course');

export default [{
  path: '/admin/train/activities/:id/courses',
  name: 'admin_train_activities_courses',
  component: Index,
  meta: {
    title: '课程列表',
    layout: 'admin',
  },
}, {
  path: '/admin/train/courses/:id/attendances',
  name: 'admin_train_courses_attendances',
  component: Attendance,
  meta: {
    title: '签到列表',
    layout: 'admin',
  },
},
];



// WEBPACK FOOTER //
// ./src/pages/admin/train/course/index.js